import React from 'react'
import Person from '../../../components/svg/person'
import CreditCard from '../../../components/svg/credit-card'
import Calendar from '../../../components/svg/calendar-rounded'
import Tag from '../../../components/svg/tag'
import ThumbsUp from '../../../components/svg/thumbs-up'
import Package from '../../../components/svg/package'
import Lock from '../../../components/svg/lock'
import Umbrella from '../../../components/svg/umbrella'

export default function FeaturesSection() {
  return (
    <div className='root'>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Person />
        <h3>Verified sellers</h3>
        <p>
          Every seller on privauto has been identity verified by us, meaning that you can bid
          or buy on any vehicle with the assurance that it’s a real listing from a real person or
          business.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <CreditCard fill='var(--primary-color)' />
        <h3>Finance and Leasing Available</h3>
        <p>
          Get prequalified and access our finance and lease options on all qualifying vehicles. Our
          concierge will walk you through all your finance options and assist in securing the best
          way to pay for your purchase.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Calendar />
        <h3>7-day Satisfaction Guarantee</h3>
        <p>
          If your vehicle arrives and you have a change of heart, you can take advantage of our
          7-day money back guarantee. We want to ensure you are happy with your purchase.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Tag fill='var(--primary-color)' />
        <h3>No Middlemen to inflate the price</h3>
        <p>
          Private party vehicle sales offer the best value for both buyer and seller. Traditionally,
          it has been a scary and painful process to buy a car this way. privauto solves that.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <ThumbsUp />
        <h3>Concierge Treatment</h3>
        <p>
          We are here to help! Our friendly and knowledgeable concierge team is available at every
          step of your purchase to ensure that your buying experience is easy and stress-free.
        </p>
      </div>

      <div className='feat flex flexDirectionColumn alignCenter'>
        <Package />
        <h3>Pickup or Delivery options</h3>
        <p>
          It's your choice, you can pick up your vehicle from one of our nearby concierge locations
          or opt to have it delivered straight to your door. Our site automatically quotes delivery
          options for you.
        </p>
      </div>

      <div className='feat flex flexDirectionColumn alignCenter'>
        <Lock fill='var(--primary-color)' />
        <h3>Safe and Secure transactions</h3>
        <p>
          We solved the mystery around how to safely purchase a vehicle privately. Once you have
          agreed on your price with the seller, we facilitate the payment and title transfer.
        </p>
      </div>

      <div className='feat flex flexDirectionColumn alignCenter'>
        <Umbrella fill='var(--primary-color)' />
        <h3>Warranty and Protection options</h3>
        <p>
          Our concierge will walk you through all of the warranty and protection options that we
          offer to protect your purchase. No pressure, just great options.
        </p>
      </div>

      <style jsx>{`
        .root {
          display: grid;
          padding: 0 3.3rem;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          grid-gap: 6.5rem;
          max-width: 166.7rem;
          margin: 0 auto;

          h3 {
            margin: 2.9rem 0 0.7rem;
            text-align: center;
            font-size: 3.2rem;
            line-height: 3.6rem;
          }

          p {
            text-align: center;
            font-size: 1.8rem;
            line-height: 2.3rem;
          }

          :global(.feat svg) {
            width: 8rem;
            height: 7.4rem;
          }
        }

        @media (max-width: 1536px) {
          .root {
            grid-gap: 5rem;
          }
        }

        @media (max-width: 1200px) {
          .root {
            grid-gap: 5rem;

            h3 {
              font-size: 2.8rem;
              line-height: 3rem;
            }

            p {
              font-size: 1.6rem;
            }
          }
        }

        @media (max-width: 1024px) {
          .root {
            grid-template-columns: 1fr 1fr;

            p {
              font-size: 1.4rem;
              line-height: 1.8rem;
            }

            h3 {
              font-size: 1.6rem;
              margin: 1.6rem 0 0;
            }

            :global(.feat svg) {
              width: 7.3rem;
              height: 6.7rem;
            }
          }
        }

        @media (max-width: 600px) {
          .root {
            grid-template-rows: 1fr;
            grid-template-columns: repeat(8, minmax(22rem, 1fr));
            grid-gap: 4rem;
            overflow-x: scroll;
            overflow-y: hidden;
            scroll-snap-type: x proximity;
            -webkit-overflow-scrolling: touch;
            -ms-overflow-style: -ms-autohiding-scrollbar;

            &::-webkit-scrollbar {
              display: none;
            }

            p {
              font-size: 1.6rem;
            }

            h3 {
              font-size: 1.8rem;
            }
          }
        }

        .feat :global(svg) {
          opacity: 0.5;
        }

        .feat p {
          opacity: 0.7;
        }
      `}</style>
    </div>
  )
}
